var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmSelectRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5815 0.41848C20.1395 0.976454 20.1395 1.8826 19.5815 2.44058L8.15422 13.8679C7.59625 14.4258 6.6901 14.4258 6.13213 13.8679L0.41848 8.15423C-0.139493 7.59625 -0.139493 6.6901 0.41848 6.13213C0.976453 5.57415 1.8826 5.57415 2.44058 6.13213L7.14541 10.8325L17.5639 0.41848C18.1219 -0.139493 19.028 -0.139493 19.586 0.41848H19.5815Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmSelectRight);
export default __webpack_public_path__ + "static/media/sm-select-right.88c7232cdd1d5293eb99181c66995271.svg";
export { ForwardRef as ReactComponent };